// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__PxxIj","devName":"Footer_devName__mUfM2","logoImg":"Footer_logoImg__hNX7G"};